import React, { useState } from 'react';
import './NetworkSelectModal.css';

const CHAINS = {
  // ETH 主网暂时隐藏，合约未部署
  // '0x1': { 
  //   id: '0x1', 
  //   name: 'Ethereum', 
  //   icon: 'Ξ',
  //   rpcUrls: ['https://rpc.ankr.com/eth'], 
  //   nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }, 
  //   blockExplorerUrls: ['https://etherscan.io/'] 
  // },
  '0x38': { 
    id: '0x38', 
    name: 'BSC', 
    icon: 'BNB',
    rpcUrls: ['https://bsc-dataseed.binance.org/'], 
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 }, 
    blockExplorerUrls: ['https://bscscan.com/'] 
  },
  '0x2b6653dc': { 
    id: '0x2b6653dc', 
    name: 'TRON', 
    icon: 'TRX',
    isTron: true,
    rpcUrls: ['https://api.trongrid.io'], 
    nativeCurrency: { name: 'TRON', symbol: 'TRX', decimals: 6 }, 
    blockExplorerUrls: ['https://tronscan.org/'] 
  },
};

const NetworkSelectModal = ({ isOpen, onClose, onSelectNetwork }) => {
  const [switching, setSwitching] = useState(false);
  const [error, setError] = useState('');

  const handleSelectNetwork = async (chainId) => {
    try {
      setSwitching(true);
      setError('');
      
      // 保存选择的网络到localStorage
      localStorage.setItem('selected_chain', chainId);
      
      // 波场链不需要 EVM 钱包切换，跳过 wallet_switchEthereumChain
      if (typeof window !== 'undefined' && window.ethereum && !CHAINS[chainId]?.isTron) {
        try {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId }],
          });
        } catch (switchError) {
          // 如果网络不存在，尝试添加
          if (switchError.code === 4902) {
            const chain = CHAINS[chainId];
            if (chain) {
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [{
                  chainId: chain.id,
                  chainName: chain.name,
                  rpcUrls: chain.rpcUrls,
                  nativeCurrency: chain.nativeCurrency,
                  blockExplorerUrls: chain.blockExplorerUrls,
                }],
              });
            }
          } else {
            // 如果用户拒绝或出错，仍然保存选择，但显示警告
            console.warn('网络切换失败，但已保存选择:', switchError);
          }
        }
      }
      
      // 调用回调函数
      if (onSelectNetwork) {
        onSelectNetwork(chainId);
      }
      
      // 关闭弹窗
      onClose();
    } catch (e) {
      console.error('选择网络失败:', e);
      setError('选择网络失败: ' + (e.message || '未知错误'));
    } finally {
      setSwitching(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="network-modal-overlay" onClick={onClose}>
      <div className="network-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="network-modal-header">
          <h2>选择主网</h2>
          <button className="network-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="network-modal-body">
          {error && (
            <div className="network-modal-error">
              {error}
            </div>
          )}
          
          <div className="network-modal-description">
            <p>请先选择您要使用的主网</p>
            <p className="network-modal-hint">选择后即可连接钱包</p>
          </div>

          <div className="network-list">
            {Object.values(CHAINS).map((chain) => (
              <button
                key={chain.id}
                className="network-item"
                onClick={() => handleSelectNetwork(chain.id)}
                disabled={switching}
              >
                <div className="network-item-icon">{chain.icon}</div>
                <div className="network-item-info">
                  <div className="network-item-name">{chain.name}</div>
                  <div className="network-item-symbol">{chain.nativeCurrency.symbol}</div>
                </div>
                {switching && <div className="network-item-loading">...</div>}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkSelectModal;

